import { createReducer } from '@reduxjs/toolkit';
import { constants, text as textConfig } from '@config';
import { fromCharCodeToString, fromUnicodeToString } from 'src/utils/format';

import * as metadataActions from '../actions/metadata.action';
import * as textActions from '../actions/text.action';
import { map } from 'jquery';

const initialState = {
  orderedList: {
    styles: constants.text.orderedList.styles
  },
  bulletList: {
    styles: constants.text.bulletPoints.styles
  }
};

const mapOrderedList = (state, key, listStyle) => {
  state.orderedList.styles[key] = {
    mode: textConfig.mode.custom,
    isImported: listStyle.is_imported ?? false,
    symbols: [],
    pattern: []
  };

  for (const style of listStyle.level_styles) {
    state.orderedList.styles[key].symbols.push(textConfig.orderedList.stylesMapping[style.numbering_style]);
    state.orderedList.styles[key].pattern.push(style.numbering_regex);
  }
};

const mapBulletList = (state, key, bulletListStyles, characterStyles) => {
  const mapping = characterStyles;

  if (!mapping) return;

  state.bulletList.styles[key] = {
    mode: textConfig.mode.custom,
    isImported: bulletListStyles.is_imported ?? false,
    symbols: [],
    charCodes: []
  };

  for (const style of bulletListStyles.character_styles) {
    const mapStyle = mapping[style]
      ? mapping[style]
      : textConfig.bulletList.defaultCharacterStyle;
    const charCode = mapStyle.char_code ?? mapStyle.charCode;

    const symbol = (typeof charCode === 'string' && charCode.includes('U+'))
      ? fromUnicodeToString(charCode)
      : fromCharCodeToString(charCode);

    state.bulletList.styles[key].symbols.push(symbol);
    state.bulletList.styles[key].charCodes.push(charCode);
  }
};

const setListStyleFromMetadata = (state, { payload }) => {
  if (!payload.bullet_and_ordered_list) return;

  const {
    list_styles: listStyles,
    bullet_list_styles: bulletListStyles,
    character_styles: characterStylesList
  } = payload.bullet_and_ordered_list;

  const characterStyles = Array.isArray(characterStylesList) ? characterStylesList[0] : characterStylesList;

  if (listStyles) {
    Object.entries(listStyles).forEach(([key, styles]) => {
      mapOrderedList(state, key, styles);
    });
  }

  if (bulletListStyles && characterStyles) {
    Object.entries(bulletListStyles).forEach(([key, styles]) => {
      mapBulletList(state, key, styles, characterStyles);
    });
  }
};

export default createReducer(initialState, builder => {
  builder
    .addCase(metadataActions.setMetadata, setListStyleFromMetadata)
    .addCase(textActions.setListStyle.fulfilled, setListStyleFromMetadata);
});
